import React from 'react';
import Styles from './RenaultDaster.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import { cars } from './Data';
import Hero from '../HeroForm/Hero';

const RenaultDaster = () => {
  return (


    <div className={Styles.main_page}>
      <h2>Renault Duster</h2>
      {/*Carousel*/}
      <div className={Styles.car_image}>
        <Carousel images={cars} />
      </div>


     <Hero selectedCar="Renault Duster" /> 

    </div>

  );
}

export default RenaultDaster;
